import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReactNode } from 'react';

export type SortableListItem<TID extends UniqueIdentifier> = {
  id: TID;
  content: ReactNode;
};
export const SortableItem = <TID extends UniqueIdentifier, T extends SortableListItem<TID>>({ id, content }: T) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {content}
    </div>
  );
};
